function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-code-typing:not(.animated) .animable {opacity: 0;}svg#freepik_stories-code-typing.animated #freepik--Keyboard--inject-4 {animation: 3s Infinite  linear wind;animation-delay: 0s;}svg#freepik_stories-code-typing.animated #freepik--Monitor--inject-4 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,3s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-code-typing.animated #freepik--Mouse--inject-4 {animation: 6s Infinite  linear heartbeat;animation-delay: 0s;}            @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes heartbeat {                0% {                    transform: scale(1);                }                10% {                    transform: scale(1.1);                }                30% {                    transform: scale(1);                }                40% {                    transform: scale(1);                }                50% {                    transform: scale(1.1);                }                60% {                    transform: scale(1);                }                100% {                    transform: scale(1);                }            }        ");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "active",
  height: "200%"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  result: "DILATED",
  operator: "dilate",
  radius: 2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#32DFEC",
  floodOpacity: 1,
  result: "PINK"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "PINK",
  in2: "DILATED",
  operator: "in",
  result: "OUTLINE"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "OUTLINE"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))), /*#__PURE__*/React.createElement("filter", {
  id: "hover",
  height: "200%"
}, /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  result: "DILATED",
  operator: "dilate",
  radius: 2
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff0000",
  floodOpacity: 0.5,
  result: "PINK"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "PINK",
  in2: "DILATED",
  operator: "in",
  result: "OUTLINE"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "OUTLINE"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
})));

var SvgDsa = function SvgDsa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-code-typing",
    viewBox: "0 0 500 500",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4",
    className: "animable animator-active",
    style: {
      transformOrigin: "77.288px 236.419px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elqczr3hggxb9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.14,262.26c-.2-.13-.15-.22,0,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      opacity: 0.2,
      transformOrigin: "32.074px 262.193px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5u1fwsk633s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.67,253.44a18.32,18.32,0,0,1-12.57,14.47l-2.48.81c-8.92,12.63-24.56,18-37.89,10.19l-3.9-2.29-10.92-13-.13,0c-3.46.72-7.37.19-9.93-2.25a3.4,3.4,0,1,1-5.51-3.25c-2.2,1.94-5.6,1.05-7.72-1.07a66.7,66.7,0,0,1,2-17.29A69.72,69.72,0,0,1,40,229.56a72.21,72.21,0,0,1,3.59-7.34c.1-.2.22-.41.34-.61a87.87,87.87,0,0,1,6.65-10l1.26-1.14c1-.87,1.91-1.72,2.88-2.58l.18-.16q2.32-2,4.71-4c2.45-2.05,4.94-4.06,7.45-6.06l.25-.2c2.15-1.7,4.32-3.39,6.48-5.07l3.26-2.52a8.94,8.94,0,0,1,1.92.45c2.67.93,3.13,3.38,5,5.06,2.46,2.25,4.82-1.53,8.61-1.41,11.65.36,7.13,12.31,12.82,10.81,24.57-6.48,20.44,24.95,9.76,31.85C121.46,241.81,126.89,245.26,125.67,253.44Z",
    style: {
      opacity: 0.2,
      transformOrigin: "80.2272px 236.216px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.84,
    cy: 242.39,
    rx: 41.44,
    ry: 40.93,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "72.84px 242.39px"
    },
    id: "elcwhj40f99bo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.84,
    cy: 240.73,
    rx: 37.78,
    ry: 37.32,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(255, 255, 255)",
      strokeMiterlimit: 10,
      transformOrigin: "72.84px 240.73px"
    },
    id: "el0dahikjht8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.24,255.44c-2.38,1.48-3.06,6.45-1.19,8.61s5.46.49,6.19-2.87a1.12,1.12,0,0,0,2,.28,2.3,2.3,0,0,0,.14-2.1c-.18-.15-.11-.26,0,0,1.22,1,3.32-.09,3.61-2.16-.89,5.5,4.11,10.3,7.79,7.5-1.09,2.34.34,5.41,2.24,6s3.94-.53,5.76-1.77,3.69-2.67,5.68-2.76c1.73-.08,3.34.9,5,1.48,5.26,1.83,11.42-.6,15.44-6.11,2.66,4.55,9.21,2.87,11-2.79.37,2.65,2.18,4.67,4.21,4.69s4.06-1.94,4.76-4.57v0c0,2.51,2.28,3.74,3.88,2.13a9.38,9.38,0,0,0,2.31-8.87c2.72-.11,5.36-3.27,5.77-6.93s-1.43-7.34-4.06-8.06c4.52-1.87,8-8,8.22-14.29s-3.06-12.09-7.49-13.55a4.7,4.7,0,0,0-5.08,1.06c-.53-3.57-2.15-6.76-4.54-8.36-3.8-2.57-9.09-.81-11.92,4a9.41,9.41,0,0,0,.22-8.38c-1.26-2.33-3.76-3.27-5.88-2.17-.45-3.83-3.41-6.55-6.3-5.81s-5.22,4.84-5,8.71c-.27-3.12-4-3.89-5.28-1.27.11.24-.06.1,0,0-1.84-3.86-5.58-5.84-9.05-4.71-3.69,1.21-6.79,5.84-7.27,10.9a6.51,6.51,0,0,0-9,.25c-2.73,2.46-4.31,7.14-3.83,11.32-2.87-2.83-7.7-1.28-9.67,3.1s-.62,10.58,2.71,12.42c-2.29.35-4.31,3.39-4.31,6.47s2,5.72,4.33,5.64c-2.32.2-4.51,2.94-4.85,6.05S30,254.76,32.24,255.44Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "74.867px 230.19px"
    },
    id: "elwfys767gk3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1s94pb85t3q"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "73.1857px 226.85px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.33,241.1a4.32,4.32,0,0,0-4-1,4.81,4.81,0,0,0-3,3.72c-.32,1.81.52,3.81,1.9,4.15,1.69.42,3.42-1.47,5.14-1.26a11.1,11.1,0,0,1,1.77.58c2.47.69,5-1.53,7.06-3.61a9.82,9.82,0,0,0,2-2.49,4.06,4.06,0,0,0,.26-3.29c-.6-1.35-2.1-1.46-3.36-1.2a13.44,13.44,0,0,0-7,4.1c.07-.51.14-1,.22-1.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "72.477px 242.309px"
    },
    id: "el336gpppo5g5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.45,236.17a5.69,5.69,0,0,0-2.14-1.32,2.06,2.06,0,0,0-2.26,1,3.28,3.28,0,0,0,.56,3.76,5.21,5.21,0,0,0,3.13,1.17c1.14.15,2.58.12,3.17-1.21a2.88,2.88,0,0,0-.48-2.88,4.93,4.93,0,0,0-2.22-1.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "105.398px 237.819px"
    },
    id: "elm7cw5byasm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.91,215.74a11,11,0,0,0-4.74,7.32c-.18.94-.18,2.12.46,2.58a1.67,1.67,0,0,0,1.55,0l6.64-2.4a10,10,0,0,0-3,2.19,5,5,0,0,0-1.2,3.92,2.88,2.88,0,0,0,3,2.44,6.44,6.44,0,0,0,3.67-2.08,6.75,6.75,0,0,0,2.38-4.45c0-1.8-1.7-3.37-2.81-2.15A24.48,24.48,0,0,0,63,218.52a8.59,8.59,0,0,0,2.09-2.58,4.33,4.33,0,0,0,.27-3.44c-2.16-5.09-5.15,2.75-6.55,3.52C56.18,217.48,53.28,213.76,49.91,215.74Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "55.3313px 221.294px"
    },
    id: "elvec3418n5v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.23,238.69a3.17,3.17,0,0,0,.53,2.88,1.3,1.3,0,0,0,2.12-.68,8.1,8.1,0,0,0-4,3.09c-1,1.64-.77,4.39.69,4.91.91.33,1.89-.31,2.75-.95a56.84,56.84,0,0,0,6.93-6.15,3.16,3.16,0,0,0,2.48,4.14c1.64.08,3.2-1.14,4.63-2.32,1.75-1.45,3.77-3.61,3.36-6.09a3,3,0,0,0-4.23-2.26c-1.7.75-3,2.56-4.21,4.3,1-1.78-.31-4.25-1.93-4.43s-3.16,1.14-4.17,2.68c1.86-1.4,2.33-4.77-.12-5C42.44,232.65,39.65,237,39.23,238.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "48.0219px 240.893px"
    },
    id: "elmier6cdyon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.77,228.09c-1.38-.58-3.14.68-3.54,2.53s.63,3.87,2.08,4.06a4.43,4.43,0,0,0-2.83,2,3.56,3.56,0,0,0-.63,2.14,2,2,0,0,0,1.94,1.8,5.36,5.36,0,0,0,2.59-1.08,4.38,4.38,0,0,0-2.55,1.09,2.57,2.57,0,0,0-.43,3c.52.64,1.39.47,2.11.17a11.31,11.31,0,0,0,4.38-3.37,3.53,3.53,0,0,0,3.59,1.73,3.47,3.47,0,0,0,2.14-3.9,2.51,2.51,0,0,0-2.2-1.94,5.77,5.77,0,0,0-2.88.75,7.41,7.41,0,0,0,2.37-3.38c.37-1.44-.35-3.29-1.51-3.11-1.31.21-2,2.52-3.06,3.4C90.09,232.55,92.53,229.24,89.77,228.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "91.7666px 236.008px"
    },
    id: "elgdhphhib5kp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.36,222.6c-1.5,1.37-2.07,3.93-2,6.21.06,2.52.91,5.16,2.71,6.06,2.36,1.18,5.39-1.53,5.89-4.83a8.08,8.08,0,0,0-3.41-7.92A2.87,2.87,0,0,0,66.36,222.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "68.7064px 228.494px"
    },
    id: "elnst44azit89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.08,218.86l.6.64a2.62,2.62,0,0,0-4.34-.17,4.75,4.75,0,0,0-.12,5.56,2.71,2.71,0,0,0,4.36-.66,4,4,0,0,0,5.23-1.57c1.25-1.93,1-5.17-.59-6.26s-4.18.85-4,3.25l-.7-1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "83.9917px 220.9px"
    },
    id: "elf4t63va95u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.41,221.52a13.71,13.71,0,0,0-2.93,5.27c-.47,2.07.19,4.62,1.79,5s3.12-1.35,4.07-3.15a8.06,8.06,0,0,0,1.07-5.4c-.44-1.77-2.45-2.71-3.49-1.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "101.918px 226.556px"
    },
    id: "elntvlgv25ypk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.12,210.83a2.3,2.3,0,0,0-3.72-1.08,5.11,5.11,0,0,0-1.26,5,3.93,3.93,0,0,0,3.35,2.91,3.69,3.69,0,0,0,3.61-4.09,3.21,3.21,0,0,0,3.43,1.46,8.94,8.94,0,0,0,3.63-1.94c1.54-1.21,3.19-3,3.07-5.25a3.2,3.2,0,0,0-2.8-3.12,5.13,5.13,0,0,0-3.86,2.05c-.85.95-1.56,2.12-2.48,3s-2.15,1.35-3.1.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "78.5872px 211.19px"
    },
    id: "elm2xvv2mykg",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-4",
    className: "animable",
    style: {
      transformOrigin: "261.035px 320.845px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.68,
    y: 272.76,
    width: 230.67,
    height: 97.15,
    style: {
      fill: "rgb(78, 70, 152)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "261.015px 321.335px"
    },
    id: "eltl8uvoot9xa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 278.64,
    width: 21.7,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "161.35px 284.645px"
    },
    id: "elx37hjtsgo8t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.83,
    y: 337.2,
    width: 34.18,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "353.92px 343.205px"
    },
    id: "elpietdlpkte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.91,
    y: 293.64,
    width: 21.1,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "360.46px 299.645px"
    },
    id: "el4iqzsloprqw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 322.39,
    width: 21.7,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "161.35px 328.395px"
    },
    id: "elnenv6mywykh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 307.92,
    width: 17.57,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "159.285px 313.925px"
    },
    id: "el6i5rt5yahrh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "156.505px 299.285px"
    },
    id: "ell288qxp35h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.84,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "171.845px 299.285px"
    },
    id: "el0ma4l9dsaaej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.17,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "187.175px 299.285px"
    },
    id: "elnoohdcnz8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.5,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "202.505px 299.285px"
    },
    id: "el52n19xzghpn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.84,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "217.845px 299.285px"
    },
    id: "elku5sy8glpbf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.17,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "233.175px 299.285px"
    },
    id: "el46kvn4s2kzg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "248.505px 299.285px"
    },
    id: "elq9vrnvn8z7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.84,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "263.845px 299.285px"
    },
    id: "elfgo0gcqqpnu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.17,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "279.175px 299.285px"
    },
    id: "el340ow4lxy02",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.5,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "294.505px 299.285px"
    },
    id: "eltc4j3pg6fri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.84,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "309.845px 299.285px"
    },
    id: "eld8175faq264",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.17,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "325.175px 299.285px"
    },
    id: "elh7l5gk9nxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.51,
    y: 293.28,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "340.515px 299.285px"
    },
    id: "eluyne3xigvon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 352.02,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "156.505px 358.025px"
    },
    id: "el3lpgqvuko4q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.84,
    y: 352.02,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "171.845px 358.025px"
    },
    id: "el5mn3lc8pk4t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.17,
    y: 352.02,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "187.175px 358.025px"
    },
    id: "el853emq8y2hh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.5,
    y: 352.02,
    width: 14.66,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "203.83px 358.025px"
    },
    id: "el1no21et60qz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.48,
    y: 352.02,
    width: 73.35,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "251.155px 358.025px"
    },
    id: "elv09lv59jon",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.49,
    y: 352.02,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "318.495px 358.025px"
    },
    id: "elwbwx5ze2x3i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.82,
    y: 352.02,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "333.825px 358.025px"
    },
    id: "elxh6ptnrq8x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.18,
    y: 352.02,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "349.185px 358.025px"
    },
    id: "el56bfkyz85ba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.83,
    y: 352.02,
    width: 18.65,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "300.155px 358.025px"
    },
    id: "elycab5wovjf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 352.02,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "365.005px 358.025px"
    },
    id: "elgrfyefws1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.48,
    y: 307.92,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "177.485px 313.925px"
    },
    id: "el41n4m4etj4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.81,
    y: 307.92,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "192.815px 313.925px"
    },
    id: "el5ezvaiqg66h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.15,
    y: 307.92,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "208.155px 313.925px"
    },
    id: "elaky8qhn4co",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.48,
    y: 307.92,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "223.485px 313.925px"
    },
    id: "el1k882jvsitc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.82,
    y: 307.92,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "238.825px 313.925px"
    },
    id: "el4fmneqdk2no",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.15,
    y: 307.92,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "254.155px 313.925px"
    },
    id: "el7u8ml2k27ph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.48,
    y: 307.92,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "269.485px 313.925px"
    },
    id: "elhhd00qva2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.82,
    y: 307.92,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "284.825px 313.925px"
    },
    id: "elhn34rmsz5bp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.15,
    y: 307.92,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "300.155px 313.925px"
    },
    id: "eliyeazhku4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.48,
    y: 307.92,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "315.485px 313.925px"
    },
    id: "el83tewpz3tri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.82,
    y: 307.92,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "330.825px 313.925px"
    },
    id: "elhbbg9wq86m8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.15,
    y: 307.92,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "346.155px 313.925px"
    },
    id: "elzdz9r92fqx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.01 307.92 371.01 334.58 359 334.58 359 319.94 355.48 319.94 355.48 307.92 371.01 307.92",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "363.245px 321.25px"
    },
    id: "el4zxkxus5doo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 322.56,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "181.005px 328.565px"
    },
    id: "elbova3rnklle",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.33,
    y: 322.56,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "196.335px 328.565px"
    },
    id: "el9zwfir1mddl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.66,
    y: 322.56,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "211.665px 328.565px"
    },
    id: "eloomuaeg6yj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 322.56,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "227.005px 328.565px"
    },
    id: "elyve0nv2f7na",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.33,
    y: 322.56,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "242.335px 328.565px"
    },
    id: "elghub9rcstbo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.67,
    y: 322.56,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "257.675px 328.565px"
    },
    id: "elyqjh8re7yv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 322.56,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "273.005px 328.565px"
    },
    id: "elxk7vrtu8jrf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.33,
    y: 322.56,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "288.335px 328.565px"
    },
    id: "el9nzrjlvdxvj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.67,
    y: 322.56,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "303.675px 328.565px"
    },
    id: "elazkddz2xqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 322.56,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "319.005px 328.565px"
    },
    id: "elaazujqblcx5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.33,
    y: 322.56,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "334.335px 328.565px"
    },
    id: "elsrm3jmzyilm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.67,
    y: 322.56,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "349.675px 328.565px"
    },
    id: "elfwgx6qbok2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.48,
    y: 337.2,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "174.485px 343.205px"
    },
    id: "elze7d71xk6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.81,
    y: 337.2,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "189.815px 343.205px"
    },
    id: "el2axexth0xo4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.15,
    y: 337.2,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "205.155px 343.205px"
    },
    id: "elwm3em7m9xp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.48,
    y: 337.2,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "220.485px 343.205px"
    },
    id: "el07835irycw7a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.81,
    y: 337.2,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "235.815px 343.205px"
    },
    id: "eljwry7s10q2p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.15,
    y: 337.2,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "251.155px 343.205px"
    },
    id: "el0gudbzmcr2z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.48,
    y: 337.2,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "266.485px 343.205px"
    },
    id: "elg5pvwuc3dz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.82,
    y: 337.2,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "281.825px 343.205px"
    },
    id: "elrgbqlqh0c9s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.15,
    y: 337.2,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "297.155px 343.205px"
    },
    id: "el11p7g7da7ue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.48,
    y: 337.2,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "312.485px 343.205px"
    },
    id: "eluu6m0ehushp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.82,
    y: 337.2,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "327.825px 343.205px"
    },
    id: "elc443dyhajmq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "181.005px 285.365px"
    },
    id: "eluqgglwt8yf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.33,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "196.335px 285.365px"
    },
    id: "el9v0uwn1uus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.66,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "211.665px 285.365px"
    },
    id: "elztwsrye65xc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "227.005px 285.365px"
    },
    id: "el9y3w1ztd0lm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.33,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "242.335px 285.365px"
    },
    id: "elxrdb73ce79g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.67,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "257.675px 285.365px"
    },
    id: "elr13j3iny0ld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "273.005px 285.365px"
    },
    id: "elsds9t0lzaeh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.33,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "288.335px 285.365px"
    },
    id: "elh9nrygprtfn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.67,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "303.675px 285.365px"
    },
    id: "elpxc0othiv1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "319.005px 285.365px"
    },
    id: "el5m6gwstfm14",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.33,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "334.335px 285.365px"
    },
    id: "elg4zo1ax2o18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.67,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "349.675px 285.365px"
    },
    id: "el0n0030eb26jg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359,
    y: 279.36,
    width: 12.01,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "365.005px 285.365px"
    },
    id: "el6wznm1dwiwv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.5,
    y: 337.2,
    width: 14.55,
    height: 12.01,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "157.775px 343.205px"
    },
    id: "ell5chlz130f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.68 273.38 150.5 271.78 373.22 271.78 376.39 273.36 145.68 273.38",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "261.035px 272.58px"
    },
    id: "el233upvals06",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hands--inject-4",
    className: "animable",
    style: {
      transformOrigin: "257.555px 365.631px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "el9jdmwbp7vt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.33,440l-4.69-28.25a23.07,23.07,0,0,0-6.35-11.06c-9.33-9-21.66-18.24-22.19-30-.81-18-3.62-17.49-3.32-21.94a54.06,54.06,0,0,0,3.21-6.6,38.47,38.47,0,0,0,1.36-5.34,3.64,3.64,0,0,1,4-2.85,6.19,6.19,0,0,1,3.39,1.59,9.39,9.39,0,0,1,2.54,6.5,27.79,27.79,0,0,1-1,7.06,46.16,46.16,0,0,1,3,12.41c1.07-3.3,1.88-6.63,2.95-9.92.22-.12.14-.38.35-.5-1.51-3.24-.23-3.06-3.22-10.19-5-12-10.64-23.57-14.65-38.65a8.57,8.57,0,0,1,.09-4.24c1.45-4.31,5.89-3.32,7.83-.81a8.28,8.28,0,0,1,1.2,2.18,116.46,116.46,0,0,0,9.57,18.45l10.89,16.6s3.79-3.11,4.37-4.5h0c.57-1.4.85-12.67.85-12.67s-.86,2.11-2.77,2c-1.38-.1-4.18.7-6.17-1.54a5.21,5.21,0,0,1-.18-6.54l4.93-6.66a7.48,7.48,0,0,1,7.74-.93,36.82,36.82,0,0,1,8.71,6.1,17.81,17.81,0,0,1,7.58,1.46c3.49,1.68,7.15,6.5,7.15,6.5s4.07.25,5.9,1.58c.46.33,6.67,10,4.43,17.53-1.33,4.49-2.15,11-2.75,12.76l-3.05,44.09,6.15,29-13.15,7.33A94,94,0,0,1,320,436.68Z",
    style: {
      opacity: 0.2,
      transformOrigin: "311.037px 367.529px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.67,388.48l.12-44.21c.48-1.78.87-8.34,1.89-12.91,1.74-7.66-5.1-16.9-5.58-17.2-1.92-1.19-6-1.17-6-1.17s-4-4.57-7.57-6a17.87,17.87,0,0,0-7.66-1,36.61,36.61,0,0,0-9.1-5.51,7.49,7.49,0,0,0-7.66,1.44l-4.47,7a5.21,5.21,0,0,0,.61,6.52c2.14,2.11,4.88,1.12,6.26,1.12,1.91,0,2.63-2.16,2.63-2.16s.47,11.26,0,12.69h0c-.49,1.43-4.07,4.78-4.07,4.78l-12-15.83a114.51,114.51,0,0,1-10.77-17.78,8.5,8.5,0,0,0-1.35-2.09c-2.1-2.38-6.59-3.07-7.76,1.32a8.7,8.7,0,0,0,.19,4.24c5,14.78,11.38,25.95,17.19,37.59,3.45,6.91,2.17,6.83,3.89,9.95-.2.14-.1.4-.32.53-.84,3.36-1.43,6.73-2.28,10.09a46,46,0,0,0-3.83-12.18,27.5,27.5,0,0,0,.53-7.12,9.38,9.38,0,0,0-3-6.31,6.17,6.17,0,0,0-3.49-1.36,3.64,3.64,0,0,0-3.84,3.12,37.51,37.51,0,0,1-1,5.41,54.48,54.48,0,0,1-2.76,6.8c0,4.46,2.76,3.73,4.77,21.67,1.56,14,19.56,23.21,29.36,33.3l10.44,32.86A202.3,202.3,0,0,0,356,417.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "315.507px 365.183px"
    },
    id: "elvi6k799xqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "314.129px 341.318px"
    },
    id: "el2ksps7onyoy",
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.55,328.41a7.69,7.69,0,0,1,2.29-3.46,2.93,2.93,0,0,1,3.83.13q-1.12-3.43-2.38-6.83a10.56,10.56,0,0,0-2.78-4.68c-1.42-1.16-3.76-1.4-5,0a54.05,54.05,0,0,1,.28,15.81c-.37,2.84-.85,6.1,1.06,8.23.53.43,1.45-.34,1.11-.93-.16-.28-.72-.3-1-.28A50.82,50.82,0,0,1,342.55,328.41Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "343.56px 325.172px"
    },
    id: "elz4eb7qgjijr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.55,328.41a7.69,7.69,0,0,1,2.29-3.46,2.93,2.93,0,0,1,3.83.13q-1.12-3.43-2.38-6.83a10.56,10.56,0,0,0-2.78-4.68c-1.42-1.16-3.76-1.4-5,0a54.05,54.05,0,0,1,.28,15.81c-.37,2.84-.85,6.1,1.06,8.23.53.43,1.45-.34,1.11-.93-.16-.28-.72-.3-1-.28A50.82,50.82,0,0,1,342.55,328.41Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "343.56px 325.172px"
    },
    id: "elzxlyisnezx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfthoqf8oppn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.55,328.41a7.69,7.69,0,0,1,2.29-3.46,2.93,2.93,0,0,1,3.83.13q-1.12-3.43-2.38-6.83a10.56,10.56,0,0,0-2.78-4.68c-1.42-1.16-3.76-1.4-5,0a54.05,54.05,0,0,1,.28,15.81c-.37,2.84-.85,6.1,1.06,8.23.53.43,1.45-.34,1.11-.93-.16-.28-.72-.3-1-.28A50.82,50.82,0,0,1,342.55,328.41Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "343.56px 325.172px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326.59,323.67a28.27,28.27,0,0,0,.54,5.74,7.14,7.14,0,0,0,3.2,4.61c-1-3.72-.46-7.67.08-11.48l1-7a5.17,5.17,0,0,1,.71-2.32,1.8,1.8,0,0,1,2.11-.76c-1,.58-2.27-.2-2.87-1.18a29.42,29.42,0,0,0-1.53-3.08c-1.34-1.72-4.2-2.1-6.18-1.64C324.24,312.31,326.36,317.77,326.59,323.67Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "328.94px 320.2px"
    },
    id: "elmi7syctfb6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.59,323.67a28.27,28.27,0,0,0,.54,5.74,7.14,7.14,0,0,0,3.2,4.61c-1-3.72-.46-7.67.08-11.48l1-7a5.17,5.17,0,0,1,.71-2.32,1.8,1.8,0,0,1,2.11-.76c-1,.58-2.27-.2-2.87-1.18a29.42,29.42,0,0,0-1.53-3.08c-1.34-1.72-4.2-2.1-6.18-1.64C324.24,312.31,326.36,317.77,326.59,323.67Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "328.94px 320.2px"
    },
    id: "elqeydx7a1pln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsy27kt1kgqb"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "328.94px 320.2px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.59,323.67a28.27,28.27,0,0,0,.54,5.74,7.14,7.14,0,0,0,3.2,4.61c-1-3.72-.46-7.67.08-11.48l1-7a5.17,5.17,0,0,1,.71-2.32,1.8,1.8,0,0,1,2.11-.76c-1,.58-2.27-.2-2.87-1.18a29.42,29.42,0,0,0-1.53-3.08c-1.34-1.72-4.2-2.1-6.18-1.64C324.24,312.31,326.36,317.77,326.59,323.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "328.94px 320.2px"
    },
    id: "elpuct2u66nja",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M310.27,308.25a3.51,3.51,0,0,1-1.06-2.1,3,3,0,0,0-1.17-2c-3.07,1.95-1.39,7.66-4.5,9.55-.6.37-1.37.58-1.7,1.2a1.58,1.58,0,0,0,.33,1.76,3,3,0,0,0,1.7.8,6.85,6.85,0,0,0,6.54-2.84c1.22-1.68,2.06-4.38,1.46-6.37A1.54,1.54,0,0,1,310.27,308.25Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "306.886px 310.837px"
    },
    id: "el2gpdqvs07iz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.34,345.64c0,.21-.09.48.08.62s.61-.12.81-.4a5.35,5.35,0,0,1,5.95-1.93c.81,0,1.09-1.25.56-1.86a2.89,2.89,0,0,0-2.24-.72,4.36,4.36,0,0,1-2.36-.39,2.34,2.34,0,0,1-1-2.52C279.63,340.85,279,343.24,278.34,345.64Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "282.164px 342.37px"
    },
    id: "elqlc5sethyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el27a0t72cbt5j"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "295.192px 325.225px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.27,308.25a3.51,3.51,0,0,1-1.06-2.1,3,3,0,0,0-1.17-2c-3.07,1.95-1.39,7.66-4.5,9.55-.6.37-1.37.58-1.7,1.2a1.58,1.58,0,0,0,.33,1.76,3,3,0,0,0,1.7.8,6.85,6.85,0,0,0,6.54-2.84c1.22-1.68,2.06-4.38,1.46-6.37A1.54,1.54,0,0,1,310.27,308.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "306.886px 310.837px"
    },
    id: "el7qf7a4bwwf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.34,345.64c0,.21-.09.48.08.62s.61-.12.81-.4a5.35,5.35,0,0,1,5.95-1.93c.81,0,1.09-1.25.56-1.86a2.89,2.89,0,0,0-2.24-.72,4.36,4.36,0,0,1-2.36-.39,2.34,2.34,0,0,1-1-2.52C279.63,340.85,279,343.24,278.34,345.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "282.164px 342.37px"
    },
    id: "elluox21vmmvs",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M319.06,307.49c-1.75-.23-3.6-.28-5.13-1.17-1.9-1.12-3.21-3.5-5.42-3.6-2-.09-3.43,1.71-4.54,3.33a6.07,6.07,0,0,1,3.94-5.63,9.78,9.78,0,0,1,7.15.28,26.83,26.83,0,0,1,6.2,3.87,8.31,8.31,0,0,1,2.1,2C325.83,310.5,320.6,307.7,319.06,307.49Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "313.991px 304.264px"
    },
    id: "elnzp6p6uac3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5mhfle1uix9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.06,307.49c-1.75-.23-3.6-.28-5.13-1.17-1.9-1.12-3.21-3.5-5.42-3.6-2-.09-3.43,1.71-4.54,3.33a6.07,6.07,0,0,1,3.94-5.63,9.78,9.78,0,0,1,7.15.28,26.83,26.83,0,0,1,6.2,3.87,8.31,8.31,0,0,1,2.1,2C325.83,310.5,320.6,307.7,319.06,307.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "313.991px 304.264px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.78,364.28a6.9,6.9,0,0,0,.32-.67A.76.76,0,0,0,287.78,364.28Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "287.939px 363.945px"
    },
    id: "el6xis2vkqqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.75,348.79c-.2-2.46.15-4.94.05-7.41s-.75-5.07-2.55-6.77c-2.58-2.43-9.65-1.19-7.28,3.43a3,3,0,0,0,3.67,1.37,2.67,2.67,0,0,0,1.25-3.61,12.81,12.81,0,0,1-.61,14.56,11.62,11.62,0,0,1,2.82,13.25,1.46,1.46,0,0,1,1.65,0,5,5,0,0,1,1.27,2.26c.35.81,1,1.65,1.88,1.59,1.2-2.95.81-6.3,0-9.38S291,352,290.75,348.79Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "287.076px 350.428px"
    },
    id: "els2sm9rb8tdn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.62,302.42a10,10,0,0,0-4.73-2Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "314.255px 301.42px"
    },
    id: "el3ccfhkgv4fr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.38,333.71c-.38-1.7-1.17-3.28-1.64-5-1.09-3.91-.4-8.09-.9-12.12a20.92,20.92,0,0,0-7.43-13.45l-1.79-.76a10.09,10.09,0,0,1,3.6,5.24c1.39,4.78,1.82,9.76,2.44,14.7A197.1,197.1,0,0,0,326.81,345C328,341.32,329.21,337.46,328.38,333.71Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "322.637px 323.69px"
    },
    id: "elsens2m3su8q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.34,315.93a6.29,6.29,0,0,0,2.11-4.11,17,17,0,0,0-.11-4.22,1.4,1.4,0,0,1-1.58.95,3.55,3.55,0,0,1-1.89-1.72l-.36,1.25-.15-.68-.48.61c.71,2,1.4,4.33.3,6.16a7.23,7.23,0,0,1-2.25,2.08A3.8,3.8,0,0,0,309.34,315.93Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "308.231px 311.819px"
    },
    id: "elbpol3i4526t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.28,307.1l.06.5A.8.8,0,0,0,311.28,307.1Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "311.318px 307.35px"
    },
    id: "eljcdr4ubv2n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.05,327.34c-3.5-6.89-7-13.78-10.87-20.48a66.25,66.25,0,0,0-7.64-11.17c-1.34-1.49-5.16-4.95-7.27-2.67-1.41,1.52.44,4.28-1.29,5.93.4,0,2.35-.19,2.56.07a30.41,30.41,0,0,1,6.71,19.39c1.41-1.11,3.35.43,4.45,1.85a326.39,326.39,0,0,1,19,27.1c-1.14-4.13-1.17-8.52-2.39-12.62A45,45,0,0,0,306.05,327.34Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "295.34px 319.812px"
    },
    id: "elxnz3f4a4w3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.79,344.13a43.81,43.81,0,0,0,3.13-13.84,22.65,22.65,0,0,0-3.14-12.53c-.58-.93-3-4.77-4.29-4.46-2.35.56.73,4.64,1.27,5.66,2,3.85,4.11,7.92,4,12.27-.1,3.35-1.51,6.5-2.64,9.65a20.79,20.79,0,0,0-1.41,6.86c-.17.26-.33.53-.52.77a10.27,10.27,0,0,1-6.28,4.15c1-3,1.93-6,2.9-9,.35-1.07.47-2.53-.15-3.27a2.8,2.8,0,0,0,.31-1.3,6.61,6.61,0,0,0-.85-2.3c-1.34-2.88-.89-6.23-.56-9.39.4-3.9.55-7.91-.59-11.66s-3.79-7.23-7.51-8.47l1,1-1.26-.92,2.34,4.88-.86,1.23c1.29-.68,2.94.3,3.53,1.63a8.58,8.58,0,0,1,.29,4.31,86.2,86.2,0,0,0,1.18,24.26,11.78,11.78,0,0,1-1.44,5.33,5.25,5.25,0,0,1-5,2.71,5.26,5.26,0,0,0-1.93-5.33c-2,2.8-.82,7.15-.52,10.34a112.45,112.45,0,0,0,2.33,14.36,46.42,46.42,0,0,1,2.55-12q1.62,5.92,3.26,11.85a7,7,0,0,1,.62-3.23,2.41,2.41,0,0,1,2.76-1.28,3.41,3.41,0,0,1,1.65,2.06,36.75,36.75,0,0,1,2,21.63c1.34.75,3.12-.15,3.87-1.49a9,9,0,0,0,.71-4.5Q347.13,364.14,346.79,344.13Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "338.556px 348.821px"
    },
    id: "elxdsqm0ti9n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.89,348.36c-.64,1.12,2,5.58,2.41,6.64q3.3,8.07,6.61,16.15a76.45,76.45,0,0,0-5.12-20.68C316.34,349.36,314.16,346.13,312.89,348.36Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "317.35px 359.371px"
    },
    id: "el9o8pag0sb4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.31,319.84c-.38.57-.91,1.27-1.56,1.07s-.72-1-.71-1.63q.1-5.61.19-11.23c-3,2.17-2.64,5-2.85,8.24-.12,1.87.42,10.8-.86,11.89a33.33,33.33,0,0,0,7.44-9.06C317.44,318.69,316.68,319.27,316.31,319.84Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "314.24px 318.115px"
    },
    id: "elf19lc4wpla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhnw5kgth3xg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "314.461px 341.318px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.78,364.28a6.9,6.9,0,0,0,.32-.67A.76.76,0,0,0,287.78,364.28Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "287.939px 363.945px"
    },
    id: "el52jpvikzbjh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.75,348.79c-.2-2.46.15-4.94.05-7.41s-.75-5.07-2.55-6.77c-2.58-2.43-9.65-1.19-7.28,3.43a3,3,0,0,0,3.67,1.37,2.67,2.67,0,0,0,1.25-3.61,12.81,12.81,0,0,1-.61,14.56,11.62,11.62,0,0,1,2.82,13.25,1.46,1.46,0,0,1,1.65,0,5,5,0,0,1,1.27,2.26c.35.81,1,1.65,1.88,1.59,1.2-2.95.81-6.3,0-9.38S291,352,290.75,348.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "287.076px 350.428px"
    },
    id: "elrb6lgv38yhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.62,302.42a10,10,0,0,0-4.73-2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "314.255px 301.42px"
    },
    id: "elj66c4whfgmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.38,333.71c-.38-1.7-1.17-3.28-1.64-5-1.09-3.91-.4-8.09-.9-12.12a20.92,20.92,0,0,0-7.43-13.45l-1.79-.76a10.09,10.09,0,0,1,3.6,5.24c1.39,4.78,1.82,9.76,2.44,14.7A197.1,197.1,0,0,0,326.81,345C328,341.32,329.21,337.46,328.38,333.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "322.637px 323.69px"
    },
    id: "elu70qg8o8q2s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.34,315.93a6.29,6.29,0,0,0,2.11-4.11,17,17,0,0,0-.11-4.22,1.4,1.4,0,0,1-1.58.95,3.55,3.55,0,0,1-1.89-1.72l-.36,1.25-.15-.68-.48.61c.71,2,1.4,4.33.3,6.16a7.23,7.23,0,0,1-2.25,2.08A3.8,3.8,0,0,0,309.34,315.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "308.231px 311.819px"
    },
    id: "el46ltebell5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.28,307.1l.06.5A.8.8,0,0,0,311.28,307.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "311.318px 307.35px"
    },
    id: "el4hx0n8bnt2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.05,327.34c-3.5-6.89-7-13.78-10.87-20.48a66.25,66.25,0,0,0-7.64-11.17c-1.34-1.49-5.16-4.95-7.27-2.67-1.41,1.52.44,4.28-1.29,5.93.4,0,2.35-.19,2.56.07a30.41,30.41,0,0,1,6.71,19.39c1.41-1.11,3.35.43,4.45,1.85a326.39,326.39,0,0,1,19,27.1c-1.14-4.13-1.17-8.52-2.39-12.62A45,45,0,0,0,306.05,327.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "295.34px 319.812px"
    },
    id: "elfw7vbgfv7h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.79,344.13a43.81,43.81,0,0,0,3.13-13.84,22.65,22.65,0,0,0-3.14-12.53c-.58-.93-3-4.77-4.29-4.46-2.35.56.73,4.64,1.27,5.66,2,3.85,4.11,7.92,4,12.27-.1,3.35-1.51,6.5-2.64,9.65a20.79,20.79,0,0,0-1.41,6.86c-.17.26-.33.53-.52.77a10.27,10.27,0,0,1-6.28,4.15c1-3,1.93-6,2.9-9,.35-1.07.47-2.53-.15-3.27a2.8,2.8,0,0,0,.31-1.3,6.61,6.61,0,0,0-.85-2.3c-1.34-2.88-.89-6.23-.56-9.39.4-3.9.55-7.91-.59-11.66s-3.79-7.23-7.51-8.47l1,1-1.26-.92,2.34,4.88-.86,1.23c1.29-.68,2.94.3,3.53,1.63a8.58,8.58,0,0,1,.29,4.31,86.2,86.2,0,0,0,1.18,24.26,11.78,11.78,0,0,1-1.44,5.33,5.25,5.25,0,0,1-5,2.71,5.26,5.26,0,0,0-1.93-5.33c-2,2.8-.82,7.15-.52,10.34a112.45,112.45,0,0,0,2.33,14.36,46.42,46.42,0,0,1,2.55-12q1.62,5.92,3.26,11.85a7,7,0,0,1,.62-3.23,2.41,2.41,0,0,1,2.76-1.28,3.41,3.41,0,0,1,1.65,2.06,36.75,36.75,0,0,1,2,21.63c1.34.75,3.12-.15,3.87-1.49a9,9,0,0,0,.71-4.5Q347.13,364.14,346.79,344.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "338.556px 348.821px"
    },
    id: "el6mr3ud2n7zg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.89,348.36c-.64,1.12,2,5.58,2.41,6.64q3.3,8.07,6.61,16.15a76.45,76.45,0,0,0-5.12-20.68C316.34,349.36,314.16,346.13,312.89,348.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "317.35px 359.371px"
    },
    id: "el7vqetkgq08i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.31,319.84c-.38.57-.91,1.27-1.56,1.07s-.72-1-.71-1.63q.1-5.61.19-11.23c-3,2.17-2.64,5-2.85,8.24-.12,1.87.42,10.8-.86,11.89a33.33,33.33,0,0,0,7.44-9.06C317.44,318.69,316.68,319.27,316.31,319.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "314.24px 318.115px"
    },
    id: "elf7ldxh75jki",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M324,307.59a78.74,78.74,0,0,1,2.72,20,10.81,10.81,0,0,0,.36,3.36,3.34,3.34,0,0,0,2.29,2.29",
    style: {
      fill: "none",
      transformOrigin: "326.685px 320.415px"
    },
    id: "elu04b552lz5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.11,314.16c3,6.26-.07,20.25.15,21.23a3.53,3.53,0,0,0,1.69,2.4",
    style: {
      fill: "none",
      transformOrigin: "339.03px 325.975px"
    },
    id: "el2bcz6kflfyv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.33,306.74c-.35,2-.64,4.29-1,6.28a11.54,11.54,0,0,1-4-8",
    style: {
      fill: "none",
      transformOrigin: "309.83px 309.02px"
    },
    id: "eln2ttbk40q7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,360.09,291,361",
    style: {
      fill: "none",
      transformOrigin: "292.085px 360.545px"
    },
    id: "el5807xdw0tyg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.72,361.82a12.5,12.5,0,0,0,0,5.06",
    style: {
      fill: "none",
      transformOrigin: "293.591px 364.35px"
    },
    id: "elk1mcfbr5fe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.36,343.14c.8,1.43,1.59,2.87,2.39,4.31",
    style: {
      fill: "none",
      transformOrigin: "307.555px 345.295px"
    },
    id: "elzrbre08crb9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,327.36l2.38-3.36",
    style: {
      fill: "none",
      transformOrigin: "312.19px 325.68px"
    },
    id: "elbw1tisj8dfr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.43,343.14l-.72,2.63",
    style: {
      fill: "none",
      transformOrigin: "344.07px 344.455px"
    },
    id: "eldiwg9xy70hs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.61,335.93q1-3.36,2.11-6.72",
    style: {
      fill: "none",
      transformOrigin: "339.665px 332.57px"
    },
    id: "elddrkw885bgm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.65,324a2.71,2.71,0,0,1,3.64,1.13",
    style: {
      fill: "none",
      transformOrigin: "347.47px 324.413px"
    },
    id: "elhxmo6osomx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.28,312.53a5.17,5.17,0,0,1,4.81,1.1",
    style: {
      fill: "none",
      transformOrigin: "333.685px 312.985px"
    },
    id: "elsyxev3vrdth",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.74,319.2a7.31,7.31,0,0,1,6.2-2.34",
    style: {
      fill: "none",
      transformOrigin: "289.84px 318.008px"
    },
    id: "el0ym3jewyz3uh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.71,300.34a6.7,6.7,0,0,1,5-1.18",
    style: {
      fill: "none",
      transformOrigin: "280.21px 299.706px"
    },
    id: "elp3i6dhiy6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.57,345.09a12.76,12.76,0,0,0-2.93,3.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "278.105px 346.735px"
    },
    id: "elpgq4t05inyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.53,340.55c1.58-1.13,4.1,1.39,5.55.1a2.3,2.3,0,0,0,.49-2.16,7.5,7.5,0,0,1-.29-2.29",
    style: {
      fill: "none",
      transformOrigin: "283.595px 338.614px"
    },
    id: "elfvshwb3lbpg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.12,333.61a18.11,18.11,0,0,1,1.1,12.82",
    style: {
      fill: "none",
      transformOrigin: "326.017px 340.02px"
    },
    id: "elci4lhjb628u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.74,339.78a8.33,8.33,0,0,1-1,5.5",
    style: {
      fill: "none",
      transformOrigin: "336.295px 342.53px"
    },
    id: "ela3azc9jckvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.11,436.09l-10.44-32.86c-9.8-10.09-27.8-19.32-29.36-33.3-2-17.94-4.77-17.21-4.77-21.67a54.48,54.48,0,0,0,2.76-6.8,37.51,37.51,0,0,0,1-5.41,3.64,3.64,0,0,1,3.84-3.12,6.17,6.17,0,0,1,3.49,1.36,9.38,9.38,0,0,1,3,6.31,27.5,27.5,0,0,1-.53,7.12,46,46,0,0,1,3.83,12.18c.85-3.36,1.44-6.73,2.28-10.09.22-.13.12-.39.32-.53-1.72-3.12-.44-3-3.89-9.95-5.81-11.64-12.18-22.81-17.19-37.59a8.7,8.7,0,0,1-.19-4.24c1.17-4.39,5.66-3.7,7.76-1.32a8.5,8.5,0,0,1,1.35,2.09,114.51,114.51,0,0,0,10.77,17.78l12,15.83s3.58-3.35,4.07-4.78h0c.47-1.43,0-12.69,0-12.69s-.72,2.16-2.63,2.16c-1.38,0-4.12,1-6.26-1.12a5.21,5.21,0,0,1-.61-6.52l4.47-7a7.49,7.49,0,0,1,7.66-1.44,36.61,36.61,0,0,1,9.1,5.51,17.87,17.87,0,0,1,7.66,1c3.6,1.45,7.57,6,7.57,6s4.07,0,6,1.17c.48.3,7.32,9.54,5.58,17.2-1,4.57-1.41,11.13-1.89,12.91l-.12,44.21L356,417.79",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "315.542px 365.193px"
    },
    id: "el46p2z1xi9ob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,307.59a78.74,78.74,0,0,1,2.72,20,10.81,10.81,0,0,0,.36,3.36,3.34,3.34,0,0,0,2.29,2.29",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "326.685px 320.415px"
    },
    id: "elf6yxfqur69w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.11,314.16c3,6.26-.07,20.25.15,21.23a3.53,3.53,0,0,0,1.69,2.4",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "339.03px 325.975px"
    },
    id: "elqier8xzuo6s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.33,306.74c-.35,2-.64,4.29-1,6.28a11.54,11.54,0,0,1-4-8",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "309.83px 309.02px"
    },
    id: "eldlml1fobdza",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.17,360.09,291,361",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "292.085px 360.545px"
    },
    id: "elplr81g0jfp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.72,361.82a12.5,12.5,0,0,0,0,5.06",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "293.591px 364.35px"
    },
    id: "eldr9vasa965v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.36,343.14c.8,1.43,1.59,2.87,2.39,4.31",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "307.555px 345.295px"
    },
    id: "eligvwjrp0vz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,327.36l2.38-3.36",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "312.19px 325.68px"
    },
    id: "eljcgi4790hid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.43,343.14l-.72,2.63",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "344.07px 344.455px"
    },
    id: "el09ay7imuhbhk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.61,335.93q1-3.36,2.11-6.72",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "339.665px 332.57px"
    },
    id: "elzqq5jc6pyjr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.65,324a2.71,2.71,0,0,1,3.64,1.13",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "347.47px 324.413px"
    },
    id: "eldr2m6o9oov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.28,312.53a5.17,5.17,0,0,1,4.81,1.1",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "333.685px 312.985px"
    },
    id: "el2v2ed4iksgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.74,319.2a7.31,7.31,0,0,1,6.2-2.34",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "289.84px 318.008px"
    },
    id: "elkbppjo1zch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.71,300.34a6.7,6.7,0,0,1,5-1.18",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "280.21px 299.706px"
    },
    id: "el7s6bvq2ccwb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.57,345.09a12.76,12.76,0,0,0-2.93,3.29",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "278.105px 346.735px"
    },
    id: "elxll95e5b13n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.53,340.55c1.58-1.13,4.1,1.39,5.55.1a2.3,2.3,0,0,0,.49-2.16,7.5,7.5,0,0,1-.29-2.29",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "283.595px 338.614px"
    },
    id: "el5u2vo1pxkpx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.12,333.61a18.11,18.11,0,0,1,1.1,12.82",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "326.017px 340.02px"
    },
    id: "elyj5tlqm3r3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.74,339.78a8.33,8.33,0,0,1-1,5.5",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "336.295px 342.53px"
    },
    id: "eli1hk1ovoac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el47tbsjxv3g2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.05,354.79a6.06,6.06,0,0,1-.09,2.08c-.65,3-2.53,11.78-3.22,16.58-.82,5.86-10.29,24-10.29,24s-8.72,10.84-13.16,16.48c-2.18,2.77-5.63,14-8.56,24.66q-5.55-1.68-11-3.62c-3-1.07-6-2.2-9-3.37A147.09,147.09,0,0,1,169.11,424c1.66-6,2.77-10.67,2.75-10.94-.05-.63,3.56-7.58,3.56-7.58L172.27,364l-1.86-6.31a47.39,47.39,0,0,1-1.83-10,48.34,48.34,0,0,1,1.29-15.33l5.43-8.06,2.54-.19,7.86-11s4.25-1.28,5.34,1.92-3.54,9.18-3.54,9.18l-1.59,9.87,3.78,9.24,2,.72s.66-16.27.21-19.52L196,309.73a70.54,70.54,0,0,0,3.26-7.46c.76-2.49,5.23-5,7.8-.59a6.43,6.43,0,0,1,.4,5.27c-1.05,3.05-1.92,5.45-1.92,5.45s-1,12.58-1.25,12.93,1.85,18.73,1.85,18.73l1.64.73.58-17.55,3.41-16.49s-.28-7.93,5.31-7a4.32,4.32,0,0,1,4.11,2.56c1.49,2.85.07,21.83.07,21.83l1.38,19.62,2.21,15.13,2.6-10.37s.15-14.86,9.53-16.13c0,0,2.79-.5,3.36,1.44s-1.39,5.9-1.11,9.7C239.48,350.23,239.86,353.24,240.05,354.79Z",
    style: {
      opacity: 0.2,
      transformOrigin: "204.443px 368.928px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.2,336.42c-.43-2-3.24-1.69-3.24-1.69-9.45.56-10.72,15.37-10.72,15.37l-3.39,10.14-1-15.26.1-19.67s2.86-18.82,1.59-21.77a4.31,4.31,0,0,0-3.91-2.86c-5.5-1.38-5.82,6.55-5.82,6.55l-4.64,16.18-1.91,17.45-1.58-.84s-.75-18.52-.43-18.83,2.22-12.79,2.22-12.79,1.05-2.33,2.33-5.29a6.43,6.43,0,0,0,0-5.29c-2.23-4.54-6.87-2.42-7.83,0a70.39,70.39,0,0,1-3.8,7.19l-5.3,14.49c.2,3.28-1.68,19.46-1.68,19.46l-1.91-.87-3.07-9.5,2.34-9.73s5.07-5.6,4.22-8.88-5.18-2.32-5.18-2.32L175.88,318h-2.55l-6,7.61a48.27,48.27,0,0,0-1.38,25.29l1.38,6.43v41.56s-4.12,6.66-4.12,7.29c0,.29-1.7,5.54-4.07,12.09,10.37,6.1,19.3,10.82,25.63,13.31,3,1.18,6,2.3,9,3.37,3.8-10.67,8.24-22.08,10.69-24.75,4.86-5.28,14.38-15.44,14.38-15.44s10.81-17.37,12.08-23.14c1-4.74,3.58-13.35,4.46-16.3a5.77,5.77,0,0,0,.24-2.07c-.07-1.56-.22-4.59-.22-7.26C235.36,342.2,237.62,338.39,237.2,336.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "198.196px 365.051px"
    },
    id: "elivufyz5jwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "200.264px 331.82px"
    },
    id: "elholzqd1jqw",
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.3,332.24c1.62-2,4.94-2.79,6.82-1a7.17,7.17,0,0,1,1.71,4,8.53,8.53,0,0,0,1.51,4.12c1,1.13,2.89,1.57,3.9.49.14,2.19.27,4.38.41,6.57A26.05,26.05,0,0,0,190.09,333c0-2.27-.39-4.58.14-6.8s2.24-4.36,4.52-4.47c2.52-.11,4.51,2.34,5,4.82s-.08,5-.23,7.54a22.94,22.94,0,0,0,2.16,11.21l1.59-3.22c.48,2.16,1,4.31,1.43,6.46q.62-7.11,1.24-14.21a10.36,10.36,0,0,1,.87-3.9,3.46,3.46,0,0,1,3.21-2c1.8.18,2.84,2.1,3.44,3.8,4.51,12.75,2.65,26.74.74,40.12,1.25.23,2.31-1,2.62-2.27a29,29,0,0,1,.67-3.74c.47-1.19,1.91-2.16,3-1.48,1.58,1,.48,4.06,2.13,4.91a22.82,22.82,0,0,1,4.53-10.93c1.11-1.44,2.77-2.87,4.53-2.41a3.56,3.56,0,0,1,2.37,3c.19,1.34,2.13-4.2,1.79-2.89.76-7.71-.76-8.52,0-16.24.14-1.39,2.39-3.8,1.43-4.82s-3.63-2.4-4.84-1.84-5.13,2.52-5.91,3.59c-4.92,6.79-4.58,16.61-6.11,24.85-1.31-12.56-2.6-25.33-.3-37.74,1.27-6.85,3.61-14,1.4-20.59-1-3-3.69-6-6.82-5.46-2.52.46-4,3-5.07,5.36-3.44,7.9-5,16.48-6.48,25L208.76,303a17.35,17.35,0,0,0,.58-6.74c-.41-2.24-1.94-4.43-4.16-4.9s-4.4.84-6.06,2.36c-6,5.44-8.16,13.74-10.1,21.56a15.52,15.52,0,0,0,1.16-6.31c-.21-2.14-1.57-4.32-3.67-4.79-2.73-.59-5.2,1.84-6.4,4.35s-1.78,5.42-3.69,7.45c-1.39-1.56-4-1.47-5.74-.31a11.09,11.09,0,0,0-3.65,5,46.52,46.52,0,0,0-3.87,22.48,8.23,8.23,0,0,1,8.21-4.68c-.2-1.7-.39-3.4-.59-5.11",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "200.264px 331.82px"
    },
    id: "elti4y6tnqafi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.89,348.51c-.09,1.26-.17,2.52-.26,3.78a1.82,1.82,0,0,1,2.77-.7,4.14,4.14,0,0,1,.63-2.34c.32-.76.35-1.84-.39-2.2s-1.74.58-2.21,1.44c0-.31-.07-.62-.11-.94Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "180.437px 349.631px"
    },
    id: "elabh9dq6vqo7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.23,346.25a8.84,8.84,0,0,0-2,4.18,4.31,4.31,0,0,1,1.47-1.08,1.48,1.48,0,0,1,1.66.38c.22.3.3.74.64.91a.79.79,0,0,0,1-.36,2.28,2.28,0,0,0,.25-1.1,6.08,6.08,0,0,0-.12-2.17,2.11,2.11,0,0,0-1.44-1.51,1.3,1.3,0,0,0-1.57,1.1Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "193.764px 348.085px"
    },
    id: "elwssr3g0eyw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.12,349.69a11.36,11.36,0,0,0-2.1,5,4.38,4.38,0,0,0,1.95-1.05,3.86,3.86,0,0,1,2-1,1.39,1.39,0,0,1,1.55,1.22,9.41,9.41,0,0,1,.08-2.54,5.35,5.35,0,0,0-.18-2.52,2.13,2.13,0,0,0-1.93-1.42,1.34,1.34,0,0,0-1.18,1.8Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "207.847px 351.035px"
    },
    id: "el5tw0iaqlo7j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.91,354.71a10,10,0,0,0-1.17,4.7,1.64,1.64,0,0,1,1.47-1.46,3.28,3.28,0,0,1,2.13.57,5.78,5.78,0,0,0,.14-2.3,2,2,0,0,0-1.46-1.6c-.77-.12-1.61.61-1.4,1.35l-.23-.57Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "169.638px 357.008px"
    },
    id: "elw595mbxrrkm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eleik6dhyc1wp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.3,332.24c1.62-2,4.94-2.79,6.82-1a7.17,7.17,0,0,1,1.71,4,8.53,8.53,0,0,0,1.51,4.12c1,1.13,2.89,1.57,3.9.49.14,2.19.27,4.38.41,6.57A26.05,26.05,0,0,0,190.09,333c0-2.27-.39-4.58.14-6.8s2.24-4.36,4.52-4.47c2.52-.11,4.51,2.34,5,4.82s-.08,5-.23,7.54a22.94,22.94,0,0,0,2.16,11.21l1.59-3.22c.48,2.16,1,4.31,1.43,6.46q.62-7.11,1.24-14.21a10.36,10.36,0,0,1,.87-3.9,3.46,3.46,0,0,1,3.21-2c1.8.18,2.84,2.1,3.44,3.8,4.51,12.75,2.65,26.74.74,40.12,1.25.23,2.31-1,2.62-2.27a29,29,0,0,1,.67-3.74c.47-1.19,1.91-2.16,3-1.48,1.58,1,.48,4.06,2.13,4.91a22.82,22.82,0,0,1,4.53-10.93c1.11-1.44,2.77-2.87,4.53-2.41a3.56,3.56,0,0,1,2.37,3c.19,1.34,2.13-4.2,1.79-2.89.76-7.71-.76-8.52,0-16.24.14-1.39,2.39-3.8,1.43-4.82s-3.63-2.4-4.84-1.84-5.13,2.52-5.91,3.59c-4.92,6.79-4.58,16.61-6.11,24.85-1.31-12.56-2.6-25.33-.3-37.74,1.27-6.85,3.61-14,1.4-20.59-1-3-3.69-6-6.82-5.46-2.52.46-4,3-5.07,5.36-3.44,7.9-5,16.48-6.48,25L208.76,303a17.35,17.35,0,0,0,.58-6.74c-.41-2.24-1.94-4.43-4.16-4.9s-4.4.84-6.06,2.36c-6,5.44-8.16,13.74-10.1,21.56a15.52,15.52,0,0,0,1.16-6.31c-.21-2.14-1.57-4.32-3.67-4.79-2.73-.59-5.2,1.84-6.4,4.35s-1.78,5.42-3.69,7.45c-1.39-1.56-4-1.47-5.74-.31a11.09,11.09,0,0,0-3.65,5,46.52,46.52,0,0,0-3.87,22.48,8.23,8.23,0,0,1,8.21-4.68c-.2-1.7-.39-3.4-.59-5.11",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "200.264px 331.82px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellky840zo01j"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "189.207px 352.44px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.89,348.51c-.09,1.26-.17,2.52-.26,3.78a1.82,1.82,0,0,1,2.77-.7,4.14,4.14,0,0,1,.63-2.34c.32-.76.35-1.84-.39-2.2s-1.74.58-2.21,1.44c0-.31-.07-.62-.11-.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "180.437px 349.631px"
    },
    id: "elbfmam1naxd5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.23,346.25a8.84,8.84,0,0,0-2,4.18,4.31,4.31,0,0,1,1.47-1.08,1.48,1.48,0,0,1,1.66.38c.22.3.3.74.64.91a.79.79,0,0,0,1-.36,2.28,2.28,0,0,0,.25-1.1,6.08,6.08,0,0,0-.12-2.17,2.11,2.11,0,0,0-1.44-1.51,1.3,1.3,0,0,0-1.57,1.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "193.764px 348.085px"
    },
    id: "elm6rg1gv5ph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.12,349.69a11.36,11.36,0,0,0-2.1,5,4.38,4.38,0,0,0,1.95-1.05,3.86,3.86,0,0,1,2-1,1.39,1.39,0,0,1,1.55,1.22,9.41,9.41,0,0,1,.08-2.54,5.35,5.35,0,0,0-.18-2.52,2.13,2.13,0,0,0-1.93-1.42,1.34,1.34,0,0,0-1.18,1.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "207.847px 351.035px"
    },
    id: "elfxc2t4j4dai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.91,354.71a10,10,0,0,0-1.17,4.7,1.64,1.64,0,0,1,1.47-1.46,3.28,3.28,0,0,1,2.13.57,5.78,5.78,0,0,0,.14-2.3,2,2,0,0,0-1.46-1.6c-.77-.12-1.61.61-1.4,1.35l-.23-.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "169.638px 357.008px"
    },
    id: "elovjubovv62c",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M159.11,418.29c2.37-6.55,4.07-11.8,4.07-12.09,0-.63,4.12-7.29,4.12-7.29V357.35l-1.38-6.43a48.27,48.27,0,0,1,1.38-25.29l6-7.61h2.55l8.66-10.36s4.34-1,5.18,2.32-4.22,8.88-4.22,8.88l-2.34,9.73,3.07,9.5,1.91.87s1.88-16.18,1.68-19.46l5.3-14.49a70.39,70.39,0,0,0,3.8-7.19c1-2.42,5.6-4.54,7.83,0a6.43,6.43,0,0,1,0,5.29c-1.28,3-2.33,5.29-2.33,5.29s-1.9,12.47-2.22,12.79.43,18.83.43,18.83l1.58.84,1.91-17.45,4.64-16.18s.32-7.93,5.82-6.55a4.31,4.31,0,0,1,3.91,2.86c1.27,2.95-1.59,21.77-1.59,21.77L218.8,345l1,15.26,3.39-10.14s1.27-14.81,10.72-15.37c0,0,2.81-.29,3.24,1.69s-1.84,5.78-1.84,9.59c0,2.67.15,5.7.22,7.26a5.77,5.77,0,0,1-.24,2.07c-.88,3-3.42,11.56-4.46,16.3-1.27,5.77-12.08,23.14-12.08,23.14s-9.52,10.16-14.38,15.44c-2.45,2.67-6.89,14.08-10.69,24.75",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "198.157px 365.071px"
    },
    id: "elgla0sseq67k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,340.52a6,6,0,0,1-1.42,5.7",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "187.397px 343.37px"
    },
    id: "elgqauqpaqzzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.84,354.5c1.37-2.12,2.71-5.05,2.34-7.55-.72-4.91-3-10.56-2-15.42.64-3.1,1.28-6.21,1.93-9.31",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "173.041px 338.36px"
    },
    id: "elhmuyahkfvk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.71,308.12a9.81,9.81,0,0,1,5,0c0-.47,0-.93.05-1.4",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "214.235px 307.42px"
    },
    id: "eliyux9jcedol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.58,301.88a3.2,3.2,0,0,0,5-2.67",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "201.08px 300.822px"
    },
    id: "elp60hlpp27xd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.72,336.59a6.13,6.13,0,0,0-4.59,6.33l2.45.74",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "232.419px 340.125px"
    },
    id: "elil1ip1ldqjh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.54,337.81c.11,1.68-.1,5.69,0,7.37",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "202.542px 341.495px"
    },
    id: "el73rmnz50rt4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.38,340.14q-.3,4.11-.61,8.24c0-.35,0-.7,0-1.05",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "204.075px 344.26px"
    },
    id: "elr2xrsc1w2h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.64,363.31a13.74,13.74,0,0,1-.94,9.06",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "219.358px 367.84px"
    },
    id: "elk569pe9ru2f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,348.9c-2.18,2.39-1.86,8.13-.32,11.28",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "193.512px 354.54px"
    },
    id: "eltqzg0dopg7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4,352.85a11.23,11.23,0,0,1-2.67,7.33",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "209.065px 356.515px"
    },
    id: "eliolvqlsuz0m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.41,350a10.22,10.22,0,0,0,1.49,7",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "179.099px 353.5px"
    },
    id: "elanxu8ktairf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.13,357.51a8.53,8.53,0,0,0,1.54,5.34",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "169.894px 360.18px"
    },
    id: "el5m33krojcx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.85,311.41a3.17,3.17,0,0,1,3.5.56l1.23-1.63",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "184.215px 311.155px"
    },
    id: "el2ej26hqt0ur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.11,318.75a4.16,4.16,0,0,1,5.29.89",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "194.755px 318.905px"
    },
    id: "elj2uaiid7z8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.13,323.75a6.7,6.7,0,0,1,5.69.12",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "210.975px 323.522px"
    },
    id: "elggjnioqgvlb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.48,332.14a5.41,5.41,0,0,1,5.24-2.6",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "175.1px 330.823px"
    },
    id: "elq5tc4u64dv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.77,341.7a2.84,2.84,0,0,1,2.37-2.66",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "166.955px 340.37px"
    },
    id: "el0dzcljpxbei9",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coffee--inject-4",
    className: "animable",
    style: {
      transformOrigin: "429.49px 222.2px"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 423.44,
    cy: 228.39,
    r: 41.45,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "423.44px 228.39px"
    },
    id: "elher8i0agd2u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9wpxoenb0pa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.36,229.48c-8.84,14.49-12,12.53-42.12,27-15.31,7.34-30.1-16.23-20.09-40.42.49-1.18,4.81-7.15,4.81-7.15a22.08,22.08,0,0,1,38.58-9.12,23.84,23.84,0,0,1,21.18-5.06c.35,1,.68,2,1,3,.12.38.25.75.36,1.13.38,1.17.74,2.34,1.07,3.52q1,3.36,1.84,6.76a13.55,13.55,0,0,0-9.84.59c-2.21,1.08-4.06,2.86-6.36,3.74s-5.48.38-6.36-1.92c1.11,4.62,6,3.24,10.62,4.15C472.25,217.09,474.08,223.38,470.36,229.48Z",
    style: {
      opacity: 0.2,
      transformOrigin: "440.936px 224.79px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M456.75,222.33s7.42-1,10.94-.47A6.75,6.75,0,0,1,472,224.3a2.37,2.37,0,0,1,.51,1.33l.4,5.8a2.37,2.37,0,0,1-.64,1.79c-1.45,1.51-5.82,4.26-18.76,5.25C435.28,239.86,456.75,222.33,456.75,222.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "459.543px 230.127px"
    },
    id: "elki837vg5s58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.32,207.34A27.69,27.69,0,0,1,457.4,225c0,6.91-8,30.51-28.49,33.39-21.69,3-39.13-15.52-35.41-37.86C396.08,205.05,433.91,185.7,451.32,207.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "425.2px 228.199px"
    },
    id: "eldxp6aey4k7t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.82,
    cy: 223.41,
    rx: 31.47,
    ry: 29.79,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "424.82px 223.41px"
    },
    id: "el8clccc3lka",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.76,
    cy: 224.97,
    rx: 25.84,
    ry: 24.45,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "424.76px 224.97px"
    },
    id: "el2j07vt56ofq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.29,223.41c0-16.45-14.09-29.78-31.47-29.78S393.35,207,393.35,223.41",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "424.82px 208.52px"
    },
    id: "ellvmv1oqf2mr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,243.57a28.79,28.79,0,0,0,8.3-20.16",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "452.15px 233.49px"
    },
    id: "elmlaoup2o6hq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.78,244.67a32.28,32.28,0,0,0,22,8.53,32.85,32.85,0,0,0,14.61-3.39",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "421.085px 248.935px"
    },
    id: "elzgo23iszdy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.24,239.36c.41.62.85,1.22,1.3,1.8",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "398.89px 240.26px"
    },
    id: "elowp9x533zr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.35,223.41a28.39,28.39,0,0,0,3,12.71",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "394.85px 229.765px"
    },
    id: "el7b5sywei9cr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,231.57s-5.61-3.93-14.72-.37",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "463.64px 230.639px"
    },
    id: "el9g5nkh3ou1w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.18,234.29a57.1,57.1,0,0,1-11.64,1.83",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "460.36px 235.205px"
    },
    id: "el3uzk1o680m4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.09,233.05a5.44,5.44,0,0,1-1.4.73",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "468.39px 233.415px"
    },
    id: "elyw0dvducv3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.08,198.83c-.11-.38-.24-.75-.36-1.13-1.91-5.92-4.37-12.42-7.36-19.28-.55-1.27-1.13-2.56-1.71-3.86l-.67.06c-2.87.29-5.89.65-8.25,2.28s-3.77,5.07-2.24,7.52,5.43,3.78,4.81,6.55c-6.41,3.61-14.23,3.19-21.36,5A34.78,34.78,0,0,0,425,201.6h0a36.71,36.71,0,0,0-3.24,2.72,12.81,12.81,0,0,0-1.32,1.42s0,0,0,0a4.89,4.89,0,0,0-1.13,2.54c-.25,2.67,2.18,4.49,4.77,5.65a.58.58,0,0,1,0,1.08,14.9,14.9,0,0,0-4.67,2.7l0,0a1.16,1.16,0,0,0,1,2l.4,0a7.55,7.55,0,0,1,3,.36,3.63,3.63,0,0,1,2.71,2.86c.16,2-2.15,3.86-5.15,4.09-.73.07-.17.94.9,1.12a16,16,0,0,0,6.4-.52c2.51-.6,5.19-1.47,6.61-3.62a4.52,4.52,0,0,0,.6-3.18,3.22,3.22,0,0,0-2.66-2.92,87.49,87.49,0,0,0,13.72-2.75h0l1.41-.43a13.16,13.16,0,0,0,3.87-1.69,5.39,5.39,0,0,0,1.69-1.86c1-2-.43-5.19-2.65-4.77,6.45-2.53,13.27-4,19.79-6.34C472,199.67,473.06,199.27,474.08,198.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "446.553px 201.408px"
    },
    id: "el7tu61b8afka",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-4",
    className: "animable",
    style: {
      transformOrigin: "261.009px 145.652px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "el24ddzyic9a9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.64,112.33a127,127,0,0,1-19.9,14c-36.41,21.54-77.54,34.44-119.38,40.73s-84.44,6.1-126.6,2.63c-8.28-.68-16.7-1.52-24.31-4.86-6.45-2.84-12.3-7.78-15-14.17,9.13-10.4,17.62-20.92,27.07-30.85q3.38-3.55,6.92-7c2-1.91,4-3.79,6.14-5.63C162,105.11,164.43,103,167,101c3.55-2.76,7.29-5.41,11.29-7.94,1-.63,2-1.24,2.93-1.84,99.71-62,173.1-41.74,222.06,0Q408.85,96,414,101c2.08,2,4.09,4.09,6,6.19.22.22.42.45.63.69Q422.7,110.11,424.64,112.33Z",
    style: {
      opacity: 0.2,
      transformOrigin: "272.045px 112.023px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.58,102.39,93.11,103.92l5.07-7.61a13.17,13.17,0,0,1,10.94-5.85H412.68a13.14,13.14,0,0,1,10.24,4.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "260.845px 97.19px"
    },
    id: "elwaeevwrog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.16,
    y: 152.67,
    width: 86.68,
    height: 86.68,
    rx: 34.15,
    style: {
      fill: "rgb(117, 117, 117)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "257.5px 196.01px"
    },
    id: "ela6epbenxcma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.91,203.34v12.32a7,7,0,0,0,7,7h42.27a7,7,0,0,0,7-6.95c.05-5.55.35-12.37.35-12.37Z",
    style: {
      fill: "rgb(153, 153, 153)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "258.22px 213px"
    },
    id: "elnpt1u65n4a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.62,207.45H137.41a6.33,6.33,0,0,1-5.9-4L93.38,105.56A3.9,3.9,0,0,1,97,100.24H425a3.9,3.9,0,0,1,3.64,5.32l-38.13,97.86A6.33,6.33,0,0,1,384.62,207.45Z",
    style: {
      fill: "rgb(191, 191, 191)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "261.01px 153.845px"
    },
    id: "el1es10a6h7fz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.45 198.93 134.98 198.93 100.38 106.44 420.89 106.44 386.45 198.93",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "260.635px 152.685px"
    },
    id: "el02g8pkdoj24z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.18,
    y: 207.32,
    width: 56.06,
    height: 3.84,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "258.21px 209.24px"
    },
    id: "elmw9fkucu48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.72,195H172.14c-1,0-1.9-.44-2.08-1L144.8,113.71c-.28-.9.51-1.63,1.77-1.63H375.29c1.26,0,2,.73,1.76,1.63L351.8,194C351.62,194.51,350.69,195,349.72,195Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "260.919px 153.54px"
    },
    id: "ellqtfidgokjb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.06 193.13 172.8 193.13 151.33 122.62 370.53 122.62 349.06 193.13",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "260.93px 157.875px"
    },
    id: "elo13gnelw8cl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.1,140.13H164.73c-.83,0-1.37.44-1.21,1a1.81,1.81,0,0,0,1.76,1h33.18c.82,0,1.4-.44,1.31-1S198.92,140.13,198.1,140.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "181.636px 141.133px"
    },
    id: "elahhk2wais8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.21,146.22H170.83c-.81,0-1.35.43-1.2,1a1.77,1.77,0,0,0,1.71.95h28.22c.81,0,1.38-.43,1.29-.95S200,146.22,199.21,146.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "185.232px 147.198px"
    },
    id: "elimbdhxj4ag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmvjf9xfo8i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.29,152.1h-32.2c-.8,0-1.32.42-1.18.92a1.76,1.76,0,0,0,1.7.92h32c.79,0,1.36-.41,1.27-.92S201.09,152.1,200.29,152.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "184.388px 153.023px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.33,157.78H182.42c-.78,0-1.32.4-1.2.89s.85.89,1.63.89h18.81c.78,0,1.34-.4,1.25-.89S202.11,157.78,201.33,157.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "192.061px 158.67px"
    },
    id: "el5soefxtxmqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.34,163.26H171.22c-.76,0-1.28.39-1.14.87s.86.85,1.63.85h30.94c.77,0,1.32-.38,1.24-.85S203.11,163.26,202.34,163.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "186.977px 164.12px"
    },
    id: "elzhcwg05ttbj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.31,168.57H178.19c-.76,0-1.27.37-1.15.83s.83.83,1.58.83h25c.75,0,1.29-.37,1.21-.83S204.07,168.57,203.31,168.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "190.93px 169.4px"
    },
    id: "eljckvolnvnh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.25,173.7H179.54c-.75,0-1.25.36-1.13.8s.81.81,1.55.81h24.59c.74,0,1.27-.36,1.19-.81S205,173.7,204.25,173.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "192.07px 174.505px"
    },
    id: "elv3cqbmh5tyf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.16,178.66h-27c-.73,0-1.23.35-1.11.78s.8.78,1.53.78h26.83c.73,0,1.26-.35,1.18-.78S205.9,178.66,205.16,178.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "191.815px 179.44px"
    },
    id: "el2fgtb2mwz7g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el897znf9m6j7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.05,183.47H188.63c-.72,0-1.22.34-1.12.76s.77.75,1.48.75h17.33c.72,0,1.24-.34,1.17-.75S206.77,183.47,206.05,183.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "197.497px 184.225px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwohlgjz863b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.94,133.81H172.07c-.84,0-1.4.46-1.25,1a1.8,1.8,0,0,0,1.77,1h24.72c.84,0,1.43-.45,1.33-1A1.66,1.66,0,0,0,196.94,133.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "184.723px 134.809px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.73,127.26H161.11c-.85,0-1.41.48-1.24,1.07a1.92,1.92,0,0,0,1.84,1.06h34.41c.85,0,1.46-.48,1.35-1.06A1.69,1.69,0,0,0,195.73,127.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "178.661px 128.323px"
    },
    id: "elv9wze6481qt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.9,188.13H178.21c-.71,0-1.19.33-1.08.73s.78.73,1.49.73h28.55c.7,0,1.22-.32,1.15-.73S207.61,188.13,206.9,188.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "192.72px 188.86px"
    },
    id: "elywuxqxnisys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwijgk9xc3ea"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "209.82 142.35 216.29 142.35 215.97 139.88 209.45 139.88 209.82 142.35",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "212.87px 141.115px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhh4zb1quyz8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "210.72 148.37 217.08 148.37 216.77 145.98 210.36 145.98 210.72 148.37",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "213.72px 147.175px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxmjv6swe3i"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "211.59 154.17 217.84 154.17 217.54 151.87 211.25 151.87 211.59 154.17",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "214.545px 153.02px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elt9iq7o0ozx"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "212.43 159.78 218.58 159.78 218.28 157.56 212.1 157.56 212.43 159.78",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "215.34px 158.67px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqtia0er5f2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "213.25 165.2 219.29 165.2 219 163.05 212.93 163.05 213.25 165.2",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "216.11px 164.125px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ela3bc3lnuocn"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "214.03 170.44 219.97 170.44 219.7 168.36 213.72 168.36 214.03 170.44",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "216.845px 169.4px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6nido039jh4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "214.8 175.51 220.64 175.51 220.38 173.5 214.5 173.5 214.8 175.51",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "217.57px 174.505px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldsci4sltcx5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "215.53 180.41 221.28 180.41 221.03 178.47 215.24 178.47 215.53 180.41",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "218.26px 179.44px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eln0k3baeojah"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "216.25 185.17 221.91 185.17 221.66 183.28 215.96 183.28 216.25 185.17",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "218.935px 184.225px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxgkpzw4ae0l"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "208.88 136.12 215.47 136.12 215.14 133.56 208.5 133.56 208.88 136.12",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "211.985px 134.84px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfzi830kkp0c"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "207.91 129.65 214.62 129.65 214.28 126.99 207.51 126.99 207.91 129.65",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "211.065px 128.32px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elm0is92xhf6k"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "216.94 189.78 222.51 189.78 222.27 187.95 216.66 187.95 216.94 189.78",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "219.585px 188.865px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.05,179.44c0-.43.56-.78,1.29-.78h95.82c.73,0,1.22.35,1.1.78a1.62,1.62,0,0,1-1.54.78H252.39C251.66,180.22,251.06,179.87,251.05,179.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.164px 179.444px"
    },
    id: "eldgwhc2efq04",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.13,175.31H296.07c-.74,0-1.3-.36-1.25-.81s.69-.8,1.44-.8h53.33c.74,0,1.24.36,1.11.8A1.63,1.63,0,0,1,349.13,175.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "322.769px 174.509px"
    },
    id: "elknwnur40ea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1l3otn4jfqo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.48,175.31H267c-.74,0-1.34-.36-1.33-.81s.61-.8,1.36-.8H283.6c.74,0,1.32.36,1.28.8S284.22,175.31,283.48,175.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "275.276px 174.505px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M317.92,170.23H243.08c-.75,0-1.38-.37-1.41-.83s.56-.83,1.32-.83h75.24c.75,0,1.3.37,1.21.83S318.68,170.23,317.92,170.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "280.559px 169.4px"
    },
    id: "el79dpef19k1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8zrggif4sxd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.43,168.57h5.34c.75,0,1.4.37,1.44.83s-.54.83-1.29.83h-5.31c-.75,0-1.4-.37-1.45-.83S226.68,168.57,227.43,168.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "230.184px 169.4px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.75,164.13c-.1.47-.8.85-1.57.85H256.66c-.77,0-1.39-.38-1.4-.85s.61-.87,1.37-.87h70.91C328.31,163.26,328.85,163.65,328.75,164.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "292.011px 164.12px"
    },
    id: "eldg4tqkkaq8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.87,163.26h20c.77,0,1.41.39,1.43.87s-.59.85-1.35.85H227.05c-.76,0-1.42-.38-1.48-.85S226.1,163.26,226.87,163.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "236.933px 164.12px"
    },
    id: "el9rk0wps4gsj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.28,157.78h76.94c.78,0,1.36.4,1.29.89s-.75.89-1.53.89H226.47c-.77,0-1.45-.4-1.5-.89S225.5,157.78,226.28,157.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "264.741px 158.67px"
    },
    id: "eln8mwa8g1cm9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.23,153.94c-.79,0-1.41-.41-1.39-.92s.68-.92,1.48-.92h40.59c.8,0,1.37.42,1.28.92s-.8.92-1.59.92Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "296.519px 153.02px"
    },
    id: "el375eplg3wdq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.68,152.1h35.13c.8,0,1.44.42,1.44.92s-.65.92-1.44.92H225.88c-.8,0-1.48-.41-1.54-.92S224.88,152.1,225.68,152.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "243.293px 153.02px"
    },
    id: "elb5gv8h2b479",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.93,148.13H260.22c-.8,0-1.46-.43-1.46-.95s.65-1,1.46-1h97.25c.81,0,1.34.43,1.19,1A1.81,1.81,0,0,1,356.93,148.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "308.723px 147.158px"
    },
    id: "elexos70kh594",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.65,142.11H273.56c-.82,0-1.47-.44-1.45-1s.7-1,1.52-1h85.59c.82,0,1.36.44,1.2,1A1.83,1.83,0,0,1,358.65,142.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "316.279px 141.113px"
    },
    id: "eluxsugwyfovd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elijewf49c5za"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.45,135.86H342.63c-.84,0-1.41-.45-1.28-1a1.77,1.77,0,0,1,1.76-1H361c.84,0,1.39.46,1.22,1A1.86,1.86,0,0,1,360.45,135.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "351.791px 134.858px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.16,135.86H264.73c-.83,0-1.51-.45-1.5-1s.68-1,1.52-1h65.82c.84,0,1.42.46,1.31,1A1.71,1.71,0,0,1,330.16,135.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "297.562px 134.864px"
    },
    id: "elpf14wtcn8wg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,183.47h60.43c.72,0,1.27.34,1.22.76s-.65.75-1.37.75H229.19c-.72,0-1.34-.34-1.39-.75S228.3,183.47,229,183.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "259.225px 184.225px"
    },
    id: "elql6y9itp1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.52,188.13h92.84c.7,0,1.21.33,1.12.73s-.72.73-1.43.73H229.68c-.71,0-1.32-.32-1.36-.73S228.81,188.13,229.52,188.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "275.904px 188.86px"
    },
    id: "eltoan4n0x5mj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.91,129.39H279.65c-.85,0-1.51-.48-1.48-1.06s.74-1.07,1.6-1.07h47.54c.86,0,1.46.48,1.35,1.07A1.74,1.74,0,0,1,326.91,129.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "303.421px 128.328px"
    },
    id: "elb0iimdho8qa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrjr6y8fp2ic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.25,129.39h-43c-.85,0-1.6-.48-1.66-1.06s.57-1.07,1.43-1.07h43.25c.85,0,1.54.48,1.53,1.07S267.1,129.39,266.25,129.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "244.693px 128.325px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqmzwmqxtjc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.85,183.47c.72,0,1.26.34,1.2.76s-.69.75-1.41.75H298c-.71,0-1.25-.34-1.2-.75s.67-.76,1.39-.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "300.426px 184.225px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elco3bb7ha9a4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.54,179.44c0,.43-.55.78-1.28.78H237.9c-.73,0-1.35-.35-1.38-.78s.53-.78,1.26-.78h6.39C244.9,178.66,245.52,179,245.54,179.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "241.029px 179.44px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eld9r53a3uk8c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.29,158.67c-.09.49-.8.89-1.57.89h-7.44c-.78,0-1.34-.4-1.27-.89s.78-.89,1.56-.89h7.48C321.83,157.78,322.39,158.18,322.29,158.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "317.153px 158.67px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el59hyf6gew9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.5,163.26c.77,0,1.29.39,1.16.87a1.66,1.66,0,0,1-1.61.85h-5.93c-.77,0-1.29-.38-1.18-.85a1.62,1.62,0,0,1,1.6-.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "342.303px 164.12px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4vudazzlhlc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.51,148.13c-.8,0-1.47-.43-1.5-.95s.62-1,1.43-1h6.31c.81,0,1.47.43,1.48,1s-.64.95-1.44.95Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "251.62px 147.155px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.57,117.34a2.13,2.13,0,0,1-2.1,3,4.44,4.44,0,0,1-3.94-3,2.13,2.13,0,0,1,2.08-3A4.42,4.42,0,0,1,162.57,117.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "159.55px 117.341px"
    },
    id: "elmhvuclpoiub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.71,117.39a2.2,2.2,0,0,1-2.2,3,4.27,4.27,0,0,1-3.84-3,2.21,2.21,0,0,1,2.18-3A4.24,4.24,0,0,1,170.71,117.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "167.693px 117.391px"
    },
    id: "el9ualocygqxm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.94,117.34a2.27,2.27,0,0,1-2.29,3,4.09,4.09,0,0,1-3.75-3,2.28,2.28,0,0,1,2.28-3A4.06,4.06,0,0,1,178.94,117.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "175.922px 117.341px"
    },
    id: "ell52t5d5djlq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz3p5m83czml"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "100.38 106.44 127.33 178.47 159.84 106.44 100.38 106.44",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "130.11px 142.455px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhhn7s9iz4l"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "145.85 198.93 199.78 106.44 256.23 106.44 176.86 198.93 145.85 198.93",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "201.04px 152.685px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eliq4qzy2mdl9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "280.56 105.98 196.5 198.93 209.45 198.93 296.52 106.44 280.56 105.98",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "246.51px 152.455px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvsb3hm6qh7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "297.16 198.93 389.54 106.44 402.58 106.44 307.33 198.93 297.16 198.93",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "349.87px 152.685px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-4",
    className: "animable",
    style: {
      transformOrigin: "235.99px 313.78px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.9,239.07H150.81a5,5,0,0,0-5,5v10.26a5,5,0,0,0,5,5h5.51l4.18,9.47,5.89-9.47h5.51a5,5,0,0,0,5-5V244A5,5,0,0,0,171.9,239.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "161.355px 253.935px"
    },
    id: "el8ktxlgukrln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.42,244.94a1,1,0,0,1,1-1,1,1,0,0,1,1,.93,1,1,0,0,1-1,1A1,1,0,0,1,158.42,244.94Zm.22,2.09h1.61v6.86h-1.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "159.42px 248.915px"
    },
    id: "elqhnmx7bqta",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.12,246.67v.41H166v1.29h-1.83v5.52h-1.61v-5.52h-1.13v-1.29h1.13v-.43a2.22,2.22,0,0,1,2.45-2.38,2.64,2.64,0,0,1,1.46.37l-.45,1.21a1.59,1.59,0,0,0-.89-.28C164.47,245.57,164.12,245.94,164.12,246.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "163.95px 249.074px"
    },
    id: "elspypfnv8tm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.12,240.5H215a5,5,0,0,0-5,5v10.27a5,5,0,0,0,5,5h5.52l4.17,9.47,5.89-9.47h5.52a5,5,0,0,0,5-5V245.46A5,5,0,0,0,236.12,240.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "225.55px 255.37px"
    },
    id: "elih95esk4qcg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.46,252.41h-5.39a2.08,2.08,0,0,0,2.23,1.65,2.46,2.46,0,0,0,1.86-.75l.86,1a3.85,3.85,0,0,1-6.55-2.4,3.41,3.41,0,0,1,3.54-3.51,3.34,3.34,0,0,1,3.47,3.55C219.48,252.07,219.47,252.26,219.46,252.41Zm-5.4-1.06H218a1.86,1.86,0,0,0-1.94-1.67A1.89,1.89,0,0,0,214.06,251.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "215.978px 251.913px"
    },
    id: "elkmf4sg9dpbk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,245.8h1.6v9.53H221Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.8px 250.565px"
    },
    id: "el3ei5vji2pi1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,254.65l.61-1.22a4.62,4.62,0,0,0,2.39.68c1,0,1.44-.28,1.44-.76,0-1.31-4.24-.08-4.24-2.81,0-1.3,1.17-2.15,3-2.15a5.51,5.51,0,0,1,2.57.59l-.62,1.22a3.78,3.78,0,0,0-2-.51c-1,0-1.44.32-1.44.77,0,1.39,4.24.15,4.24,2.84,0,1.28-1.18,2.12-3.11,2.12A5.4,5.4,0,0,1,224,254.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "226.975px 251.905px"
    },
    id: "elciy64p39hs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.77,252.41h-5.39a2.08,2.08,0,0,0,2.23,1.65,2.46,2.46,0,0,0,1.86-.75l.86,1a3.85,3.85,0,0,1-6.55-2.4,3.41,3.41,0,0,1,3.54-3.51,3.34,3.34,0,0,1,3.47,3.55C237.79,252.07,237.78,252.26,237.77,252.41Zm-5.4-1.06h3.89a1.86,1.86,0,0,0-1.94-1.67A1.89,1.89,0,0,0,232.37,251.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "234.288px 251.913px"
    },
    id: "eln9ij740r9jf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.38,239.9h-21.1a5,5,0,0,0-5,4.95v10.27a5,5,0,0,0,5,5h5.52l4.17,9.47,5.89-9.47h5.52a5,5,0,0,0,5-5V244.85A5,5,0,0,0,298.38,239.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "287.83px 254.745px"
    },
    id: "eltqxcn2rstuj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.12,247.5v.41H284v1.29h-1.84v5.52h-1.6V249.2h-1.13v-1.29h1.13v-.43A2.22,2.22,0,0,1,283,245.1a2.54,2.54,0,0,1,1.45.37l-.45,1.21a1.54,1.54,0,0,0-.88-.28C282.47,246.4,282.12,246.77,282.12,247.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "281.94px 249.904px"
    },
    id: "elckh68henfxt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.42,251.29a3.66,3.66,0,1,1,3.65,3.52A3.46,3.46,0,0,1,284.42,251.29Zm5.69,0a2,2,0,1,0-2,2.15A2,2,0,0,0,290.11,251.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "288.077px 251.153px"
    },
    id: "el422f102s6hs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.23,247.78v1.53a2.6,2.6,0,0,0-.37,0,1.87,1.87,0,0,0-2,2.12v3.33h-1.61v-6.86h1.53v1A2.71,2.71,0,0,1,297.23,247.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "295.24px 251.264px"
    },
    id: "el4zfvdgvf9ww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.74,239.07h-21.1a5,5,0,0,0-5,5v10.26a5,5,0,0,0,5,5h5.52l4.17,9.47,5.89-9.47h5.52a5,5,0,0,0,5-5V244A5,5,0,0,0,359.74,239.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "349.19px 253.935px"
    },
    id: "el13cwkptfv3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.45,246.69h5.92V248h-5.92Zm0,3.11h5.92v1.29h-5.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "349.41px 248.89px"
    },
    id: "elacr1cgf3it4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.06,227.19H183a5,5,0,0,0-5,5v10.26a5,5,0,0,0,5,5h5.52l4.17,9.47,5.89-9.47h5.52a5,5,0,0,0,5-5V232.15A5,5,0,0,0,204.06,227.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "193.55px 242.055px"
    },
    id: "el3hz6etya7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.55,231.45h3.07v1.29h-1.47v9.45h1.47v1.29h-3.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "190.085px 237.465px"
    },
    id: "elsi001zjjugg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.6,243.48v-1.29h1.45v-9.45H195.6v-1.29h3.05v12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "197.125px 237.465px"
    },
    id: "elrii4nsyz4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.78,226.14h-21.1a5,5,0,0,0-5,5v10.26a5,5,0,0,0,5,5h5.52l4.18,9.47,5.89-9.47h5.51a5,5,0,0,0,5-5V231.1A5,5,0,0,0,266.78,226.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "256.23px 241.005px"
    },
    id: "el778c66iu2uh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.94,236.38c.51.16.76.51.76,1.31v2.44a.86.86,0,0,0,1,1h.27v1.29h-.65a1.91,1.91,0,0,1-2.18-2.1v-2.64c0-.43-.22-.62-.58-.62h-.42v-1.31h.42c.36,0,.58-.19.58-.62v-2.64a1.91,1.91,0,0,1,2.18-2.1h.65v1.29h-.27a.86.86,0,0,0-1,1v2.44C252.7,235.86,252.45,236.21,251.94,236.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.055px 236.405px"
    },
    id: "elv7vrg3d7dh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74,235.72V237h-.44c-.35,0-.57.19-.57.62v2.64a1.91,1.91,0,0,1-2.19,2.1h-.65V241.1h.27a.87.87,0,0,0,1-1v-2.44c0-.8.23-1.15.74-1.31-.51-.17-.74-.52-.74-1.32v-2.44a.87.87,0,0,0-1-1h-.27v-1.29h.65a1.91,1.91,0,0,1,2.19,2.1v2.64c0,.43.22.62.57.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "259.815px 236.33px"
    },
    id: "el2mohlgz5klt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.84,224.06h-21.1a5,5,0,0,0-5,5v10.26a5,5,0,0,0,5,5h5.51l4.18,9.47,5.89-9.47h5.52a5,5,0,0,0,5-5V229A5,5,0,0,0,328.84,224.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "318.29px 238.925px"
    },
    id: "el8472i43dj2l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.45,231.66a1.06,1.06,0,1,1,2.11,0,1.06,1.06,0,1,1-2.11,0Zm2.11,4.89a3,3,0,0,1-.3,1.11l-.66,1.81h-1l.52-2a1,1,0,0,1-.61-.95,1,1,0,1,1,2.09,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.523px 234.984px"
    },
    id: "eldt8evloas2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.36,403.5h21.09a5,5,0,0,0,5-5V388.28a5,5,0,0,0-5-5h-5.51l-1.61-9.47-8.46,9.47h-5.51a5,5,0,0,0-5,5v10.26A5,5,0,0,0,246.36,403.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "256.905px 388.655px"
    },
    id: "elfhdeyw88tzw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.77,391.3,249.34,393l4.43,1.65V396l-5.92-2.3v-1.39l5.92-2.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.81px 393.005px"
    },
    id: "elh3oouv9ziou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.45,386.63h1.43l-4.24,12.11h-1.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "257.045px 392.685px"
    },
    id: "elc83dy638pk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.11,392.26v1.39l-5.92,2.3v-1.34l4.43-1.65-4.43-1.66V390Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "263.15px 392.975px"
    },
    id: "eloveudh6ggfe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.24,328.75h21.09a5,5,0,0,0,5-4.95V313.53a5,5,0,0,0-5-5h-5.51l1.2-9.47-11.27,9.47h-5.51a5,5,0,0,0-5,5V323.8A5,5,0,0,0,112.24,328.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "122.785px 313.905px"
    },
    id: "elwqc1ezv1bxf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.49,322.25a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1,118.49,322.25Zm.09-8.09h1.9l-.32,6h-1.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "119.49px 318.705px"
    },
    id: "elh2d49csy9km",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.14,316.46h5.92v1.29h-5.92Zm0,3.11h5.92v1.29h-5.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "125.1px 318.66px"
    },
    id: "eldgsg6y0lb3n",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-4",
    className: "animable",
    style: {
      transformOrigin: "426.835px 321.835px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450,317.12a71.82,71.82,0,0,1-1,11.86c-2.9,17.31-12,29.93-22.76,29.93a13.68,13.68,0,0,1-2.86-.3c-11.75-2.49-20.86-20.11-20.86-41.49,0-23.08,10.62-31.25,23.72-31.25S450,294,450,317.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "426.26px 322.39px"
    },
    id: "eluvf7lfvj7rf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(&quot",
      transformOrigin: "444.009px 316.402px"
    },
    id: "elu0bb6te6xvr",
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.43,317.38c.88,12.38-1.24,24.82-4.81,36.71,8.94-7.34,13.05-18.88,16.77-29.83,2.7-7.95,5.43-16.15,4.94-24.53s-5-17.11-12.84-20a17.13,17.13,0,0,0-12.13.19c-6.59,2.65-3,4.79-.21,9.53A64.6,64.6,0,0,1,441.43,317.38Z",
    style: {
      fill: "rgb(78, 70, 152)",
      transformOrigin: "444.009px 316.402px"
    },
    id: "el22d93ts1fiw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6hprtkhuev6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.43,317.38c.88,12.38-1.24,24.82-4.81,36.71,8.94-7.34,13.05-18.88,16.77-29.83,2.7-7.95,5.43-16.15,4.94-24.53s-5-17.11-12.84-20a17.13,17.13,0,0,0-12.13.19c-6.59,2.65-3,4.79-.21,9.53A64.6,64.6,0,0,1,441.43,317.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "444.009px 316.402px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M450,317.12a71.82,71.82,0,0,1-1,11.86c-2.9,17.31-12,29.93-22.76,29.93a13.68,13.68,0,0,1-2.86-.3c-11.75-2.49-20.86-20.11-20.86-41.49,0-23.08,10.62-31.25,23.72-31.25S450,294,450,317.12Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "426.26px 322.39px"
    },
    id: "elb71a0job6q5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.05,338.35a41,41,0,0,1-7.79,14.6",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "435.155px 345.65px"
    },
    id: "elcf4g7v7klso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.8,335.45c-.12.56-.26,1.12-.41,1.68",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "439.595px 336.29px"
    },
    id: "elxywwqxtumhe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.74,317.06a40.77,40.77,0,0,1,.47,16.28",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "440.277px 325.2px"
    },
    id: "elxjybyevhjaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.57,317.12s27-10.66,47.46,0",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "426.3px 314.751px"
    },
    id: "elqdwm8ebvgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.3,285.87s2.7,10,3,26.27",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "427.8px 299.005px"
    },
    id: "eldw81mufe7k9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.07,298c.34,3.11-.2,5.75-1.21,5.91s-2.11-2.23-2.45-5.33.19-5.76,1.2-5.92S429.72,294.93,430.07,298Z",
    style: {
      fill: "rgb(191, 191, 191)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "428.239px 298.285px"
    },
    id: "elbow5qmqhvk4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.66,366.91H384a7.75,7.75,0,0,1-7.69-6.71,5.33,5.33,0,0,1-.09-1.07V284.54a5.63,5.63,0,0,1,.09-1.08,7.74,7.74,0,0,1,7.69-6.7h89.72a7.66,7.66,0,0,1,3.73,1",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "426.835px 321.835px"
    },
    id: "el376zm2npocb",
    className: "animable"
  })), _ref3, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.67,388.48l.12-44.21c.48-1.78.87-8.34,1.89-12.91,1.74-7.66-5.1-16.9-5.58-17.2-1.92-1.19-6-1.17-6-1.17s-4-4.57-7.57-6a17.87,17.87,0,0,0-7.66-1,36.61,36.61,0,0,0-9.1-5.51,7.49,7.49,0,0,0-7.66,1.44l-4.47,7a5.21,5.21,0,0,0,.61,6.52c2.14,2.11,4.88,1.12,6.26,1.12,1.91,0,2.63-2.16,2.63-2.16s.47,11.26,0,12.69h0c-.49,1.43-4.07,4.78-4.07,4.78l-12-15.83a114.51,114.51,0,0,1-10.77-17.78,8.5,8.5,0,0,0-1.35-2.09c-2.1-2.38-6.59-3.07-7.76,1.32a8.7,8.7,0,0,0,.19,4.24c5,14.78,11.38,25.95,17.19,37.59,3.45,6.91,2.17,6.83,3.89,9.95-.2.14-.1.4-.32.53-.84,3.36-1.43,6.73-2.28,10.09a46,46,0,0,0-3.83-12.18,27.5,27.5,0,0,0,.53-7.12,9.38,9.38,0,0,0-3-6.31,6.17,6.17,0,0,0-3.49-1.36,3.64,3.64,0,0,0-3.84,3.12,37.51,37.51,0,0,1-1,5.41,54.48,54.48,0,0,1-2.76,6.8c0,4.46,2.76,3.73,4.77,21.67,1.56,14,19.56,23.21,29.36,33.3l10.44,32.86A202.3,202.3,0,0,0,356,417.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.2,336.42c-.43-2-3.24-1.69-3.24-1.69-9.45.56-10.72,15.37-10.72,15.37l-3.39,10.14-1-15.26.1-19.67s2.86-18.82,1.59-21.77a4.31,4.31,0,0,0-3.91-2.86c-5.5-1.38-5.82,6.55-5.82,6.55l-4.64,16.18-1.91,17.45-1.58-.84s-.75-18.52-.43-18.83,2.22-12.79,2.22-12.79,1.05-2.33,2.33-5.29a6.43,6.43,0,0,0,0-5.29c-2.23-4.54-6.87-2.42-7.83,0a70.39,70.39,0,0,1-3.8,7.19l-5.3,14.49c.2,3.28-1.68,19.46-1.68,19.46l-1.91-.87-3.07-9.5,2.34-9.73s5.07-5.6,4.22-8.88-5.18-2.32-5.18-2.32L175.88,318h-2.55l-6,7.61a48.27,48.27,0,0,0-1.38,25.29l1.38,6.43v41.56s-4.12,6.66-4.12,7.29c0,.29-1.7,5.54-4.07,12.09,10.37,6.1,19.3,10.82,25.63,13.31,3,1.18,6,2.3,9,3.37,3.8-10.67,8.24-22.08,10.69-24.75,4.86-5.28,14.38-15.44,14.38-15.44s10.81-17.37,12.08-23.14c1-4.74,3.58-13.35,4.46-16.3a5.77,5.77,0,0,0,.24-2.07c-.07-1.56-.22-4.59-.22-7.26C235.36,342.2,237.62,338.39,237.2,336.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450,317.12a71.82,71.82,0,0,1-1,11.86c-2.9,17.31-12,29.93-22.76,29.93a13.68,13.68,0,0,1-2.86-.3c-11.75-2.49-20.86-20.11-20.86-41.49,0-23.08,10.62-31.25,23.72-31.25S450,294,450,317.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDsa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dsa.eb59fd1d.svg";
export { ForwardRef as ReactComponent };